export default "__VITE_ASSET__JrRiW6Pi__"